import styled from "styled-components";

export const _Image = styled.img`
  margin-top: 10px;
  width: 80%;
  margin: 0 auto;
  display: block;
  object-fit: cover;
`;

export const _InspirationLink = styled.a`
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  transition: 0.15s;

  span {
    margin-right: 5px;
    font-size: 12px;
    color: ${({ theme }) => theme.inspirationText};
  }

  svg {
    fill: ${({ theme }) => theme.inspirationText};
  }

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const _InspirationHeader = styled.h2`
  text-align: center;
  margin: 10px 0px 30px 0px;
`;

export const _InspirationImageContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }

  img {
    width: 100%;
    height: auto;
  }
`;
